import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import WrapperCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/WrapperCell'
import type {
  Column,
  ColumnsType,
} from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/buildColumns'
import type CoveragesByDay from 'modules/shift_management/store/internal/collections/CoveragesByDay'

export interface Props {
  coveragesByDay: CoveragesByDay
  columns: ColumnsType
}

interface EmployeesByDay {
  column: Column
  count: number
}

const EmployeesByDayGrid = ({ coveragesByDay, columns }: Props) => {
  const employeesByDayCount: EmployeesByDay[] = columns.flatMap((column: Column) => {
    const numberOfEmployees = coveragesByDay.getNumberOfEmployees(column.date)
    return { column, count: numberOfEmployees }
  })

  return (
    <>
      {employeesByDayCount.map((employeesByDay: EmployeesByDay, columnIndex: number) => {
        const { column, count } = employeesByDay
        return (
          <WrapperCell
            key={`EmployeesByDayCell-${column.headerCell}-${columnIndex}`}
            minWidth={column.minWidth}
            height="s24"
          >
            <Box flexDirection="row" height="full" padding="s4" alignItems="center">
              <Box flexDirection="row" alignItems="center">
                <Text size="100" color={count > 0 ? 'grey800' : 'grey600'}>
                  {count}
                </Text>
              </Box>
            </Box>
          </WrapperCell>
        )
      })}
    </>
  )
}

export default observer(EmployeesByDayGrid)
